import { Box, FormControl, Typography, TextField } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SCB } from './bodyTab.classes';

export const BodyTab = () => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    return (
        <Box className={SCB.root} sx={{ width: '600px' }}>
            <Box sx={{ width: '600px' }}>
                <FormControl
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        mb: 2,
                    }}
                >
                    <Typography
                        sx={{
                            marginRight: '48px',
                            fontWeight: 'bold',
                            alignContent: 'center',
                        }}
                    >
                        {t('scheduleService.bodyContent')}
                    </Typography>

                    <Controller
                        name="bodyContent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                className={SCB.bodyInput}
                                variant="outlined"
                                multiline
                                minRows={8}
                                maxRows={16}
                                fullWidth
                                placeholder={t('scheduleService.enterBodyContent')}
                                sx={{
                                    marginLeft: 'auto',
                                }}
                            />
                        )}
                    />
                </FormControl>
            </Box>
        </Box>
    );
};
